import script from "./InadimplenteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InadimplenteModal.vue?vue&type=script&setup=true&lang=js"

import "./InadimplenteModal.vue?vue&type=style&index=0&id=c79a6f5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c79a6f5e"]])

export default __exports__